import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  GetPackageOrganizationsWithPaginationDto,
  PackageStatus,
  PaginatedListOfGetPackageOrganizationsWithPaginationDto,
} from 'src/app/core/api/models';
import { PackageOrganizationsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RefreshMenuService } from 'src/app/core/services/refresh-menu.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { PackageStatusDirective } from '../../shared/package-status.directive';

@Component({
    selector: 'app-organization-packages',
    templateUrl: './organization-packages.component.html',
    styles: [``],
    imports: [BaseIndexModule, PackageStatusDirective]
})
export class OrganizationPackagesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties
  pageName = 'organizationPackages';
  modelWithPagination$: Observable<PaginatedListOfGetPackageOrganizationsWithPaginationDto>;
  items$: Observable<Array<GetPackageOrganizationsWithPaginationDto>>;
  isVisibleHelpForm;
  PackageStatusEnumValues: GetEnumValuesDto[] = [];

  /* Service Endpoint Names */
  protected currentService = inject(PackageOrganizationsService);
  paginationApiMethodName: string =
    this.currentService
      .packageOrganizationsGetPackageOrganizationsWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.packageOrganizationsCreatePackageOrganizationGet.name;

  get PackageStatus() {
    return PackageStatus;
  }
  //#endregion
  constructor(public refreshMenuService: RefreshMenuService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      // this.pageConfig.showDefaultBtns = false;
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.packageOrganization
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'id',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
      },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: `common.depositPrice`,
        name: 'depositPrice',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: `common.originalPrice`,
        name: 'originalPrice',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: `common.remainingCredit`,
        name: 'remainingCredit',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: this.localizer.status,
        name: 'packageStatus',
        hasSearch: true,
        type: 'enum',
        enumName: 'PackageStatus',
      },
      {
        title: `common.purchaseDate`,
        name: 'purchaseDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.expireDate,
        name: 'expirationDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: 'common.activationDate',
        name: 'activationDate',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  getEnumsValues() {
    this.getEnumValuesApi('PackageStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.PackageStatusEnumValues = values));
  }

  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .packageOrganizationsCancelPackageOrganization({
        body: { packageOrganizationId: id },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

}
